export default __webpack_public_path__ + "static/media/Documento com Foto.2693a646.svg";